// import { View } from 'native-base';
import React from "react";
import { View } from "react-native";

function AHStack({ children, ...props }) {
	return <View style={{ flexDirection: "row", ...props }}>{children}</View>;
}

export default AHStack;
